import { Skeleton } from "./ui/skeleton"

// Shown while the hover-card body chunk loads and while the public user is
// still being fetched, so both waits look the same.
export function UserHoverCardSkeleton() {
  return (
    <div className="flex items-center gap-2.5">
      <Skeleton className="size-(--avatar-size-xl) rounded-full" />
      <div className="flex flex-1 flex-col gap-1">
        <Skeleton className="h-4 w-28" />
        <Skeleton className="h-3.5 w-20" />
      </div>
      <Skeleton className="h-(--button-sm-size) w-24 rounded-full" />
    </div>
  )
}
